import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'

// The router mounts this page. The payload only seeds the project store.
Styxie.Initializers.MlapProjectsReviewSentiment = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => useMlapProjectStore(pinia).hydrate(props.project)
})
